import React from "react";
import SkeletonElement from "./skeletonElement";
import { Shimmer } from "..";

const SkeletonDiscuss: React.FC = () => {
  return (
    <div className="mb-3 w-full mx-auto items-center bg-[#f2f2f2] shadow-sm p-4 lg:mb-0 rounded flex flex-col overflow-hidden relative">
      <div className="flex w-full mx-auto justify-between items-center mb-3">
        <div className="flex w-[70%] gap-2">
          <SkeletonElement type="menu" />
          <div className="w-[70%]">
            <SkeletonElement type="title" />
            <div className="flex w-[50%] gap-1 items-center">
              <SkeletonElement type="title" />
              <SkeletonElement type="title" />
            </div>
          </div>
        </div>
        <SkeletonElement type="icon" />
      </div>
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <SkeletonElement type="text" />
      <div className="mt-6 border-t pt-2 w-full flex justify-between">
        <div className="flex w-[15%] justify-between">
          <SkeletonElement type="icon2" />
          <SkeletonElement type="icon2" />
          <SkeletonElement type="icon2" />
        </div>

        <div className=" float-right">
          <SkeletonElement type="icon2" />
        </div>
      </div>
      <Shimmer />
    </div>
  );
};

export default SkeletonDiscuss;
